/**
 * QR Codes Page
 * Uses design system DashboardLayout and QRCodeDashboard components
 */
import { DashboardLayout } from '../../components/dashboard/DashboardLayout';
import { QRCodeDashboard } from './QRCodeDashboard';

const QRCodePage = () => {
  return (
    <DashboardLayout currentPage="qr-codes">
      <QRCodeDashboard />
    </DashboardLayout>
  );
};

export default QRCodePage;
